import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeRedirectSignIn, consumePostLoginPath } from '../services/auth';

// The account-scoped workspace remounts during sign-in. Share this callback's
// exchange across those mounts (and StrictMode effects), without retaining tokens.
let callbackSignIn: ReturnType<typeof completeRedirectSignIn> | null = null;

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string>('Signing you in...');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const queryParams = new URLSearchParams(window.location.search);
    const params = hashParams.get('id_token') ? hashParams : queryParams;

    const idToken = params.get('id_token');
    const state = params.get('state');
    const nonce = params.get('nonce');
    window.history.replaceState(null, '', window.location.pathname);

    if (!callbackSignIn && idToken) callbackSignIn = completeRedirectSignIn(idToken, state, nonce);
    if (!callbackSignIn) {
      setStatus('Missing ID token in callback. Please try signing in again.');
      setFailed(true);
      return;
    }

    const finish = async () => {
      try {
        await callbackSignIn;
        if (!active) return;
        const stored = consumePostLoginPath() || '/';
        const target = !stored.startsWith('/') || stored.startsWith('//') || stored.includes('\\') || stored.startsWith('/auth/callback') ? '/' : stored;
        navigate(target, { replace: true });
      } catch (err: any) {
        if (!active) return;
        setFailed(true);
        setStatus(err?.message || 'Sign-in failed. Please retry.');
      }
    };

    finish();
    return () => { active = false; };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white shadow rounded-lg p-6 text-center border border-gray-200 w-full max-w-md">
        <div role={failed ? 'alert' : 'status'} className={`${failed ? '' : 'animate-pulse'} text-usda-700 text-lg font-medium`}>{status}</div>
        {failed ? <button className="mt-4 underline" onClick={()=>navigate('/',{replace:true})}>Return to the map and retry</button> : <p className="text-sm text-gray-600 mt-2">You will be redirected shortly.</p>}
      </div>
    </div>
  );
};

export default AuthCallback;
